import { render } from "./BaseScrollToTop.vue?vue&type=template&id=07d0e89e&scoped=true"
import script from "./BaseScrollToTop.vue?vue&type=script&lang=js"
export * from "./BaseScrollToTop.vue?vue&type=script&lang=js"

import "./BaseScrollToTop.vue?vue&type=style&index=0&id=07d0e89e&lang=scss&scoped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d0e89e"]])

export default __exports__